import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const communityGardenSeedlingObject = z.object({
  id: z.string().uuid(),
  communityGardenId: z.string().uuid(),
  type: z.string().nullish(),
  quantity: z.number().int().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CommunityGardenSeedlingType = z.infer<typeof communityGardenSeedlingObject>

export const propertyMap = {
  id: sql`community_garden_seedling.id`,
  communityGardenId: sql`community_garden_seedling.community_garden_id`,
  type: sql`community_garden_seedling.type`,
  quantity: sql`community_garden_seedling.quantity`,
  sourceFilter: sql`community_garden_seedling.source_filter`,
  clientId: sql`community_garden_seedling.client_id`,
  insertUserId: sql`community_garden_seedling.insert_user_id`,
  editUserId: sql`community_garden_seedling.edit_user_id`,
  createdAt: sql`community_garden_seedling.created_at`,
  updatedAt: sql`community_garden_seedling.updated_at`,
  deletedAt: sql`community_garden_seedling.deleted_at`,
}

export default communityGardenSeedlingObject
